var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFailFacial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122.774,
    height: 125.868,
    viewBox: "0 0 122.774 125.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3004",
    "data-name": "Rect\\xE1ngulo 3004",
    width: 114.714,
    height: 113.737,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2706",
    "data-name": "Grupo 2706",
    transform: "translate(-541.893 -172.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2703",
    "data-name": "Grupo 2703",
    transform: "translate(404.107 37.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2702",
    "data-name": "Grupo 2702",
    transform: "translate(137.785 134.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2701",
    "data-name": "Grupo 2701",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12287",
    "data-name": "Trazado 12287",
    d: "M54.022,10.725c5.405.225,10.846,3.3,15.333,8.137A24.047,24.047,0,0,1,76.233,36.6a18.37,18.37,0,0,1-.694,4.1,1.025,1.025,0,0,0,.173,1.134c2.052,2.464,1.336,7.78-1.282,9.512a2.476,2.476,0,0,0-1.035,1.47c-1.823,5.969-4.3,11.573-8.875,16.014a1.2,1.2,0,0,0-.327,1.29,6.93,6.93,0,0,0,7.283,5.837,26.94,26.94,0,0,1,11.862,2.4,16.085,16.085,0,0,1,9.32,16.267c-.084,1.107-.554,1.838-1.766,1.824-1.282-.012-1.775-.765-1.747-1.959a15.773,15.773,0,0,0-1.04-6.336c-2-4.977-6.064-7.165-11.012-8.166a1.312,1.312,0,0,0-1.257.468C68.43,87.537,59.428,89.714,49.491,89a31.7,31.7,0,0,1-16.821-5.939,27.529,27.529,0,0,1-2.942-2.535A1.541,1.541,0,0,0,28.209,80c-5.628,1.2-10.2,4.085-11.548,10.5a14.952,14.952,0,0,0-.331,3.863c.061,1.154-.331,1.99-1.631,2.079-1.2.082-1.818-.578-1.9-1.987-.518-8.673,4.671-15.441,13.527-17.609a31.2,31.2,0,0,1,7.549-.9c3.963.012,6.39-1.912,7.367-5.716a1.282,1.282,0,0,0-.3-1.434c-4.309-4.075-6.644-9.292-8.495-14.781-.433-1.282-.849-2.507-2.181-3.206a2.532,2.532,0,0,1-1.187-1.746c-.508-2.516-.915-5.059,1.035-7.218.52-.576.3-1.2.234-1.77a48.38,48.38,0,0,1,.037-12.209,14.38,14.38,0,0,1,1.869-5.828,8.409,8.409,0,0,1,7.223-4.007,1.764,1.764,0,0,0,1.662-.984c2.648-4.238,6.489-6.38,12.884-6.328",
    transform: "translate(3.917 3.292)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12288",
    "data-name": "Trazado 12288",
    d: "M3.667,21.513v9.8c0,.336.013.673-.007,1.009A1.742,1.742,0,0,1,1.9,34.206,1.661,1.661,0,0,1,.082,32.4c-.01-7.157-.248-14.329.136-21.466C.571,4.373,5.433.142,12.041.05,18.621-.043,25.2.021,31.784.036c1.588,0,2.266.575,2.273,1.78.007,1.245-.719,1.814-2.385,1.815-6.485.007-12.974.139-19.453-.042A8.3,8.3,0,0,0,3.64,12.146c.145,3.116.027,6.244.027,9.367",
    transform: "translate(0 0.001)",
    fill: "#060607"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12289",
    "data-name": "Trazado 12289",
    d: "M91.022,21.369c0-3.122.024-6.246-.005-9.368-.048-5.043-3.369-8.352-8.4-8.366-6.437-.018-12.874,0-19.312-.009a5.493,5.493,0,0,1-1.425-.1,1.611,1.611,0,0,1-1.24-1.848A1.541,1.541,0,0,1,62.04.109,6.446,6.446,0,0,1,63.185.028C69.575.023,75.964,0,82.352.032c6,.031,10.433,3.38,11.881,8.907a13.894,13.894,0,0,1,.409,3.561q0,9.512,0,19.025a8.3,8.3,0,0,1-.012.865c-.116,1.1-.682,1.836-1.831,1.813a1.71,1.71,0,0,1-1.759-1.881c-.042-2.305-.016-4.612-.017-6.918V21.369",
    transform: "translate(18.609 0.005)",
    fill: "#060607"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12290",
    "data-name": "Trazado 12290",
    d: "M21.112,94.99c-3.267,0-6.533.007-9.8,0A11.575,11.575,0,0,1,.062,83.144C-.008,76.467.038,69.79.055,63.111c0-1.511.672-2.269,1.841-2.24,1.154.029,1.755.788,1.758,2.32.012,6.533.15,13.07-.043,19.6a8.438,8.438,0,0,0,8.741,8.721c6.477-.2,12.966-.044,19.451-.054,1.04,0,1.939.192,2.2,1.38.29,1.345-.463,2.173-2.079,2.193-3.172.035-6.342.01-9.513.01h-1.3V94.99",
    transform: "translate(0.008 18.683)",
    fill: "#060607"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12291",
    "data-name": "Trazado 12291",
    d: "M48.509,65c-6.042,1.015-9.4-2.3-12.323-6.327a40.256,40.256,0,0,1-5.449-11.787,4.772,4.772,0,0,0-2.122-2.926c-1.376-.819-1.247-3.8.166-4.586,2.971-1.645,4.7-3.987,4.536-7.533a6.217,6.217,0,0,1,.4-2.1c1.2-3.752,4.2-5.124,7.779-3.5,1.776.806,3.523,1.525,5.515,1.026a13.211,13.211,0,0,0,1.63-.523A9.875,9.875,0,0,1,60.748,30.2c1.975,2.654,3.889,5.353,5.833,8.031.225.308.417.783.716.873,1.624.485,1.193,1.776,1.278,2.908a2.022,2.022,0,0,1-1.07,2.135,5.3,5.3,0,0,0-2.16,3.422,35.7,35.7,0,0,1-5.817,11.91c-2.892,3.7-6.159,6.736-11.019,5.513",
    transform: "translate(8.486 7.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12292",
    "data-name": "Trazado 12292",
    d: "M29,38.012a33.406,33.406,0,0,1-.222-8.5,25.849,25.849,0,0,1,.789-4.523,5.3,5.3,0,0,1,6.263-4.157,2.165,2.165,0,0,0,2.714-1.447,9.3,9.3,0,0,1,9.852-5.9c9.53.806,18.12,9.161,19.272,18.681a13.14,13.14,0,0,1-.171,5.387c-1.346-1.832-2.68-3.517-3.871-5.3A13.546,13.546,0,0,0,46.9,27.245a3.771,3.771,0,0,1-3.455-.153,10.656,10.656,0,0,0-3.933-1.281c-5.251-.472-9.509,3.339-9.974,8.884A7.811,7.811,0,0,1,29,38.012",
    transform: "translate(8.783 4.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12293",
    "data-name": "Trazado 12293",
    d: "M28.847,65.06a12.354,12.354,0,0,0,3.658-.455,9.436,9.436,0,0,0,6.575-6.089c.31-.821.537-1.236,1.465-.623a5.6,5.6,0,0,0,3.151.818q3.815-.012,7.631.02a7.256,7.256,0,0,0,3.99-.955c.694-.431.831-.133,1.074.48a10,10,0,0,0,9.944,6.831c-6.732,7-26.242,9.242-37.489-.026",
    transform: "translate(8.854 17.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12294",
    "data-name": "Trazado 12294",
    d: "M92.138,73.7c0,3.122.024,6.246-.005,9.368-.048,5.043-3.369,8.352-8.4,8.366-6.437.018-12.874,0-19.312.009a5.493,5.493,0,0,0-1.425.1,1.611,1.611,0,0,0-1.24,1.848,1.542,1.542,0,0,0,1.4,1.564,6.446,6.446,0,0,0,1.145.081c6.39.005,12.779.029,19.167,0,6-.031,10.433-3.38,11.881-8.907a13.894,13.894,0,0,0,.409-3.561q0-9.512,0-19.025a8.3,8.3,0,0,0-.012-.865c-.116-1.1-.682-1.836-1.831-1.813a1.71,1.71,0,0,0-1.759,1.881c-.042,2.305-.016,4.612-.017,6.917V73.7",
    transform: "translate(18.952 18.682)",
    fill: "#060607"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2704",
    "data-name": "Grupo 2704",
    transform: "translate(369 -506.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2009",
    "data-name": "Grupo 2009",
    transform: "translate(258 767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1078",
    "data-name": "Grupo 1078",
    transform: "translate(0 37.667) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4433",
    "data-name": "Trazado 4433",
    d: "M18.833,0A18.833,18.833,0,1,1,0,18.833,18.833,18.833,0,0,1,18.833,0Z",
    transform: "translate(0 0)",
    fill: "#dc3545"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_record",
    "data-name": "ico/record",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4276",
    "data-name": "Trazado 4276",
    d: "M0,0H32.286V32.286H0Z",
    fill: "none",
    opacity: 0.24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "close_black_24dp",
    transform: "translate(3.363 3.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7935",
    "data-name": "Trazado 7935",
    d: "M0,0H31.613V31.613H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7936",
    "data-name": "Trazado 7936",
    d: "M23.441,6.857,21.584,5l-7.363,7.363L6.857,5,5,6.857l7.363,7.363L5,21.584l1.857,1.857,7.363-7.363,7.363,7.363,1.857-1.857-7.363-7.363Z",
    transform: "translate(1.586 1.586)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFailFacial);
export default __webpack_public_path__ + "static/media/icon_fail_facial.cb7d36c25a78c648245a9503a7555fb2.svg";
export { ForwardRef as ReactComponent };